import React from "react";
import { Eye, EyeOff, Pencil, X } from "lucide-react";
import { useIntl } from "react-intl";
import "./IndicatorActions.sass";

const ACTION_ICON_SIZE = 12;

/**
 * 👁 ✏️ ✕ of an indicator in the legend and in the pane headers
 * (po-chart-visual-spec.md §5.2). 👁 is shown only with `onToggleVisible`;
 * ✏️ is disabled without `onEdit`.
 *
 * @param {object}   props
 * @param {string}   props.label - "Name parameters", for the accessible names
 * @param {boolean}  props.isVisible
 * @param {() => void} [props.onToggleVisible]
 * @param {() => void} [props.onEdit]
 * @param {() => void} props.onRemove
 */
const IndicatorActions = ({ label, isVisible, onToggleVisible, onEdit, onRemove }) => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });
  const visibilityTitle = t(isVisible ? "futures.chart.indicators.hide" : "futures.chart.indicators.show");
  const VisibilityIcon = isVisible ? Eye : EyeOff;

  const actions = [
    onToggleVisible && {
      key: "visibility",
      title: visibilityTitle,
      icon: <VisibilityIcon size={ACTION_ICON_SIZE} aria-hidden="true" />,
      onClick: onToggleVisible,
      isPressed: !isVisible,
    },
    {
      key: "edit",
      title: t("futures.chart.indicators.settings"),
      icon: <Pencil size={ACTION_ICON_SIZE} aria-hidden="true" />,
      onClick: onEdit,
    },
    {
      key: "remove",
      title: t("futures.chart.indicators.remove"),
      icon: <X size={ACTION_ICON_SIZE} aria-hidden="true" />,
      onClick: onRemove,
    },
  ].filter(Boolean);

  return (
    <span className="indicator-actions">
      {actions.map(({ key, title, icon, onClick, isPressed }) => (
        <button
          key={key}
          type="button"
          className="indicator-actions__btn"
          aria-label={`${title} ${label}`}
          aria-pressed={isPressed}
          title={title}
          disabled={!onClick}
          onClick={onClick}
        >
          {icon}
        </button>
      ))}
    </span>
  );
};

export default IndicatorActions;
